






































































import { defineComponent, useContext } from '@nuxtjs/composition-api';
import { SfImage } from '@storefront-ui/vue';

import SvgImage from '~/components/General/SvgImage.vue';
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  name: 'ReviewsPayMethod',
  components: {
    SfImage,
    SvgImage,
  },
  setup() {
    const {
      $config: { currentSite },
    } = useContext();
    return {
      addBasePath,
      currentSite,
    };
  },
  data() {
    return {
      payicons: [
        'applepay-icon',
        'visa',
        'paypal',
        'mastercard',
        'americanexpress',
        'alipay',
        'wechat',
        'union',
      ],
    };
  },
  mounted() {
    const { trustbox } = this.$refs;
    // @ts-ignore
    if (window.Trustpilot) {
      // @ts-ignore
      window.Trustpilot.loadFromElement(trustbox);
    }
  },
});
